const prices = {
    "Unterstufe": {
        name: "Unterstufe",
        prices: {
            "Minigruppe": "14.90",
            "Einzelunterricht": "29.80"
        }
    },
    "Mittelstufe": {name: "Mittelstufe", prices: {"Minigruppe": "15.90", "Einzelunterricht": "31.80"}},
    "Oberstufe": {name: "Oberstufe", prices: {"Minigruppe": "16.90", "Einzelunterricht": "33.80"}},
    "Matura": {name: "Matura", prices: {"Minigruppe": "17.90", "Einzelunterricht": "35.80"}},
    "Universitaet": {name: "Universität", prices: {"Einzelunterricht": "35.80"}},
};
const weekCoursesSummerGroup = {
    "Minikurs": {"price": "180", "amount": "10", "name": "Minikurs 10 Einheiten"},
    "Maxikurs": {"price": "360", "amount": "20", "name": "Maxikurs 20 Einheiten"},
    "Einzeltag": {"price": "38", "amount": "2", "name": " Einzeltag 2 Einheiten"}
};
const weekCoursesSummerSingle = {
    "Minikurs": {"price": "360", "amount": "10", "name": "Minikurs 10 Einheiten"},
    "Maxikurs": {"price": "720", "amount": "20", "name": "Maxikurs 20 Einheiten"},
    "Einzeltag": {"price": "76", "amount": "2", "name": " Einzeltag 2 Einheiten"}
};
const summerWeek = {
    "Grundlagenwiederholung": {
        "name": "Grundlagenwiederholung",
        "image": "https://wilk-lernhilfe.at/img/Grundlagenwiederholung1zu1.jpg",
        "description": "Wiederholung wichtiger Themen für die nächste Schulstufe.",
        "groupSizes": {
            "Minigruppe": weekCoursesSummerGroup,
            "Einzelunterricht": weekCoursesSummerSingle
        }
    },
    "Nachpruefungsvorbereitung": {
        "name": "Nachprüfungsvorbereitung",
        "image": "https://wilk-lernhilfe.at/img/Nachpruefung1zu1.jpg",
        "description": "Intensive Vorbereitung ewährleistet maximale Erfolgschancen bei der Nachprüfung",
        "groupSizes": {
            "Minigruppe": weekCoursesSummerGroup,
            "Einzelunterricht": weekCoursesSummerSingle
        }
    },
    "Maturavorbereitung": {
        "name": "Maturavorbereitung",
        "image": "https://wilk-lernhilfe.at/img/Maturakurs1zu1.jpg",
        "description": "Intensive Vorbereitung gewährleistet maximale Erfolgschancen bei der Matura!",
        "groupSizes": {
            "Minigruppe": weekCoursesSummerGroup,
            "Einzelunterricht": weekCoursesSummerSingle
        }
    }
};
const startSummer = moment('2020-08-03');
const pricesProductsValidUntil = '2020-09-30';
const courses = {
    "Sommerintensivkurs": {
        "name": "Sommerintensivkurs",
        "description": "Nachprüfungskurse, Maturavorbereitung und Grundlagenwiederholung",
        "url": "https://wilk-lernhilfe.at/de/Nachhilfe/Ferienintensivkurse/Sommerintensivkurs",
        "Weeks": [
            {
                "courses": summerWeek,
                "startDate": startSummer.format('YYYY-MM-DD'),
                "endDate": startSummer.add(4, 'd').format('YYYY-MM-DD')
            },
            {
                "courses": summerWeek,
                "startDate": startSummer.add(3, 'd').format('YYYY-MM-DD'),
                "endDate": startSummer.add(4, 'd').format('YYYY-MM-DD')
            },
            {
                "courses": summerWeek,
                "startDate": startSummer.add(3, 'd').format('YYYY-MM-DD'),
                "endDate": startSummer.add(4, 'd').format('YYYY-MM-DD')
            },
            {
                "courses": summerWeek,
                "startDate": startSummer.add(3, 'd').format('YYYY-MM-DD'),
                "endDate": startSummer.add(4, 'd').format('YYYY-MM-DD')
            },
            {
                "courses": summerWeek,
                "startDate": startSummer.add(3, 'd').format('YYYY-MM-DD'),
                "endDate": startSummer.add(4, 'd').format('YYYY-MM-DD')
            }]
    }
    ,
    "Osterintensivkurs":
        null,
    "Weihnachtsintensivkurs":
        null

};
const linkPricesLowerGrades = 'https://wilk-lernhilfe.at/de/Preise/Preise-Unterstufe';
const imagePricesLowerGrades = 'PreiseUnterstufe.jpg';
const linkPricesMiddleGrades = 'https://wilk-lernhilfe.at/de/Preise/Preise-Mittelstufe';
const imagePricesMiddleGrades = 'PreiseMittelstufe.jpg';
const linkPricesUpperGrades = 'https://wilk-lernhilfe.at/de/Preise/Preise-Oberstufe';
const imagePricesUpperGrades = 'PreiseOberstufe.jpg';
const linkPricesLeavers = 'https://wilk-lernhilfe.at/de/Preise/Preise-Matura';
const imagePricesLeavers = 'Matura.jpg';
const linkPricesStudents = 'https://wilk-lernhilfe.at/de/Preise/Preise-Studenten';
const imagePricesStudents = 'PreiseStudenten.jpg';


var handleHover = function (evObj) {
    var $this = $(this);

    if (!$this.hasClass('open')) {
        return true;
    }

    if (evObj.type === 'mouseleave') {
        // on mouseleave...
        handleHover.timer = setTimeout(function () {
            $this.removeClass('open');
        }, 2000);

    } else if (evObj.type === 'mouseenter') {
        // on mouseenter...
        if (handleHover.timer) { // find timer and clear it
            clearTimeout(handleHover.timer);
            delete handleHover.timer;
        }
    }
};

$('.dropdown-menu').hover(handleHover);

var handleInitializeMap = function initialize() {
    if ($('#gmaps-container').size() !== 0) {
        var myLatlng = new google.maps.LatLng(48.25999, 16.398156);
        var mapOptions = {
            center: myLatlng,
            zoom: 15,
            scrollwheel: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP
        };
        var map = new google.maps.Map(document.getElementById("map_canvas"),
            mapOptions);
        //console.log("TestInitialize");
        var contentString = '<div id="content" style="text-align:center">'
            + '<h4 id="firstHeading" class="firstHeading">WILK Lernhilfe</h4>'
            + '<div id="bodyContent">'
            + '<p><h6>Hermann-Bahr-Straße 18/4A</h6>'
            + '<a href="tel:00436502780441">'
            + '<h5> ☎  (+43) 650 278 04 41 </h5></a> </a>'
            + '</p>' + '</div>' + '</div>';


        var marker = new google.maps.Marker({
            position: myLatlng,
            map: map,
            title: 'WILK Lernhilfe'
        });
        var infowindow = new google.maps.InfoWindow({
            content: contentString,
            maxWidth: 500
        });
        infowindow.open(map, marker);
        google.maps.event.addListener(marker, 'click', function () {
            infowindow.open(map, marker);
        });
    }

};
$(() => {
    //setTimeout(()=>{google.maps.event.addDomListener(window, 'load', handleInitializeMap)}, 10000);
    //google.maps.event.addDomListener(window, 'load', handleInitializeMap);
    let wilk_cookie_use = Cookies.get('wilk_cookie_use');
    if (typeof wilk_cookie_use === 'undefined') {
        setTimeout(function () {
            $('#cookie-hinweis').show("slide", {"direction": "down"}, "swing", 5000);
        }, 1000);
    }
    setCookieHandlers();
    checkGoogleMaps();
    checkYouTube();

    console.info("page load success");
    generateLdJson();
    addTopicRadioClickHandler();
    init_form_button_handler();
});

function checkGoogleMaps(){
    let gomap_use = Cookies.get('gomap_use');
    let gomap_use_set = !(typeof gomap_use === 'undefined');
    let kontakt_page = $('#kontakt1').length === 1;
    let kontakt2_page = $('#kontakt2').length === 1;
    console.debug("Google Maps cookie set: " + gomap_use_set);
    console.debug("Is Kontakt page: " + kontakt_page);
    console.debug("Is Kontakt2 page: " + kontakt2_page);
    if (gomap_use_set && kontakt2_page) {
        console.debug("Init maps...");
        handleInitializeMap();
    }
    if (gomap_use_set && kontakt_page) {
        console.debug("Load kontakt2 page...");
        window.location = "/de/Kontakt2";
    }
    if (!gomap_use_set && kontakt2_page) {
        console.debug("Load kontakt page...");
        window.location = "/de/Kontakt";
    }

}

function checkYouTube(){
    let yout_use = Cookies.get('yout_use');
    let yout_use_set = !(typeof yout_use === 'undefined');
    let youtube_page = $('#youtube1').length === 1;
    let youtube2_page = $('#youtube2').length === 1;
    console.debug("YouTube cookie set: " + yout_use_set);
    console.debug("Is youtube page: " + youtube_page);
    console.debug("Is youtube2 page: " + youtube2_page);
    if (yout_use_set && youtube2_page) {
        console.debug("Init maps...");
        handleInitializeMap();
    }
    if (yout_use_set && youtube_page) {
        console.debug("Load youtube2 page...");
        window.location = "/de/VideoYouTube2";
    }
    if (!yout_use_set && youtube2_page) {
        console.debug("Load youtube page...");
        window.location = "/de/VideoYouTube";
    }

}

function setCookieHandlers() {
    $('#cookie-accept').on('click', function () {
        Cookies.set('wilk_cookie_use', 'active', {expires: 365});
        $('#cookie-hinweis').hide("slide", {"direction": "down"}, "swing", 5000);
    });
    $('#gm-allow').on('click', function () {
        Cookies.set('gomap_use', 'active', {expires: 365});
    });
    $('#gm-disallow').on('click', function () {
        Cookies.remove('gomap_use');
    });
    $('#yout-allow').on('click', function () {
        Cookies.set('yout_use', 'active', {expires: 365});
    });
    $('#yout-disallow').on('click', function () {
        Cookies.remove('yout_use');
    });
}

function init_form_button_handler() {
    let form = $('#contact-form');
    form.find('button#absenden').on('click', function () {
        let hp_input = form.find("input#gender");
        let valid_form_input = form.find('[name="anreden"]')[0].validity.valid
            && form.find('[name="nachname"]')[0].validity.valid
            && form.find('[name="vorname"]')[0].validity.valid
            && form.find('[name="email"]')[0].validity.valid
            && form.find('[name="telefonnummer"]')[0].validity.valid
            && form.find('[name="nachricht"]')[0].validity.valid;
        if (valid_form_input) {
            if (hp_input.val() === "") {
                hp_input.val("popocatepetl");
                console.log("No entry in gender")
            } else {
                console.log("Bot!!!");
            }
        }
    })
}

function addTopicRadioClickHandler() {
    if ($('#fach-0').is(':checked') === true) {
        $('#anderfach').attr('required', 'required');
        $('#anderfach-row').show();
    }
    $('#fach-radio-group').find('input[type=radio]').click((event) => {
        let radioInput = $(event.currentTarget);
        if (radioInput.val() === "0") {
            $('#anderfach').attr('required', 'required');
            $('#anderfach-row').show();

        } else {
            $('#anderfach').removeAttr('required');
            $('#anderfach-row').hide();
        }

    });
}

function generateLdJson() {
    let url = $(location).attr("href");
    //console.log(url);
    let split = url.split('/');
    let page = split[split.length - 1];
    //console.log(page);
    switch (page) {
        case 'Preise-Unterstufe':
            generatePriceListProductLdJson(imagePricesLowerGrades, 'Nachhilfe Unterstufe Minigruppe'
                , linkPricesLowerGrades, prices.Unterstufe.prices.Minigruppe,
                'Nachhilfe Minigruppe für die 1. bis zur 8.Schulstufe');
            generatePriceListProductLdJson(imagePricesLowerGrades, 'Nachhilfe Unterstufe Einzelunterricht'
                , linkPricesLowerGrades, prices.Unterstufe.prices.Einzelunterricht,
                'Nachhilfe Einzelunterricht für die 1. bis zur 8.Schulstufe');
            break;
        case 'Preise-Mittelstufe':
            generatePriceListProductLdJson(imagePricesMiddleGrades, 'Nachhilfe Mittelstufe Minigruppe'
                , linkPricesMiddleGrades, prices.Mittelstufe.prices.Minigruppe,
                'Nachhilfe Minigruppe für die 9. und 10.Schulstufe');
            generatePriceListProductLdJson(imagePricesMiddleGrades, 'Nachhilfe Mittelstufe Einzelunterricht'
                , linkPricesMiddleGrades, prices.Mittelstufe.prices.Einzelunterricht,
                'Nachhilfe Einzelunterricht für die 9. und 10.Schulstufe');
            break;
        case 'Preise-Oberstufe':
            generatePriceListProductLdJson(imagePricesUpperGrades, 'Nachhilfe Oberstufe Minigruppe'
                , linkPricesUpperGrades, prices.Oberstufe.prices.Minigruppe,
                'Nachhilfe Minigruppe für die 11. bis 13.Schulstufe');
            generatePriceListProductLdJson(imagePricesUpperGrades, 'Nachhilfe Oberstufe Einzelunterricht'
                , linkPricesUpperGrades, prices.Oberstufe.prices.Einzelunterricht,
                'Nachhilfe Einzelunterricht für die 11. bis 13.Schulstufe');
            break;
        case 'Preise-Studenten':
            generatePriceListProductLdJson(imagePricesStudents, 'Nachhilfe Studentinnen und Studenten Einzelunterricht'
                , linkPricesStudents, prices.Universitaet.prices.Einzelunterricht,
                'Nachhilfe Einzelunterricht Studentinnen und Studenten');
            break;
        case 'Preise-Matura':
            generatePriceListProductLdJson(imagePricesLeavers, 'Nachhilfe Matura Minigruppe'
                , linkPricesLeavers, prices.Matura.prices.Minigruppe,
                'Nachhilfe Minigruppe für Matura');
            generatePriceListProductLdJson(imagePricesLeavers, 'Nachhilfe Matura Einzelunterricht'
                , linkPricesLeavers, prices.Matura.prices.Einzelunterricht,
                'Nachhilfe Einzelunterricht für Matura');
            break;
        case 'Nachhilfe-Mathematik':
            generateLoopForLdJson(generatePriceList_Mathematik_LdJson, false)
            break;
        case 'Nachhilfe-Java':
            generateLoopForLdJson(generatePriceList_Java_LdJson, true);
            break;
        case 'Nachhilfe-Mechanik':
            generateLoopForLdJson(generatePriceList_Mechanik_LdJson, true);
            break;
        case 'Nachhilfe-CPP':
            generateLoopForLdJson(generatePriceList_CPP_LdJson, true);
            break;
        case 'Nachhilfe-C':
            generateLoopForLdJson(generatePriceList_CPP_LdJson, true);
            break;
        case 'Sommerintensivkurs':
            createSummerCourseLdJson()
            break;
        default:
            //console.log("NO MATCH");
            break;
    }


}

function generateLoopForLdJson(generator, skip_lower_grades) {
    for (let level in prices) {
        let priceDict = prices[level].prices;
        if (!(skip_lower_grades === true && level === 'Unterstufe')) {
            for (let groupSize in priceDict) {
                // noinspection JSUnfilteredForInLoop
                generator(groupSize, prices[level].name, priceDict[groupSize]);
            }
        }
    }
}

function generatePriceList_Mathematik_LdJson(groupSize, level, price) {
    generatePriceListProductLdJson('Mathematik1zu1.jpg', 'Nachhilfe ' + level + ' Mathematik ' + groupSize
        , 'https://wilk-lernhilfe.at/de/Nachhilfe/Faecher/Nachhilfe-Mathematik', price, 'Nachhilfe ' + groupSize + ' für Mathematik ' + level);
}

function generatePriceList_Java_LdJson(groupSize, level, price) {
    generatePriceListProductLdJson('Java1zu1.jpg', 'Nachhilfe ' + level + ' Java ' + groupSize
        , 'https://wilk-lernhilfe.at/de/Nachhilfe/Faecher/Nachhilfe-Java', price, 'Nachhilfe ' + groupSize + ' für Java ' + level);
}

function generatePriceList_Mechanik_LdJson(groupSize, level, price) {
    generatePriceListProductLdJson('mechanik1zu1.jpg', 'Nachhilfe ' + level + ' Mechanik ' + groupSize
        , 'https://wilk-lernhilfe.at/de/Nachhilfe/Faecher/Nachhilfe-Mechanik', price, 'Nachhilfe ' + groupSize + ' für Mechanik ' + level);
}

function generatePriceList_CPP_LdJson(groupSize, level, price) {
    generatePriceListProductLdJson('C1zu1.jpg', 'Nachhilfe ' + level + ' C++ ' + groupSize
        , 'https://wilk-lernhilfe.at/de/Nachhilfe/Faecher/Nachhilfe-CPP', price, 'Nachhilfe ' + groupSize + ' für C++ ' + level);
}

function generatePriceList_C_LdJson(groupSize, level, price) {
    generatePriceListProductLdJson('C1zu1.jpg', 'Nachhilfe ' + level + ' C ' + groupSize
        , 'https://wilk-lernhilfe.at/de/Nachhilfe/Faecher/Nachhilfe-C', price, 'Nachhilfe ' + groupSize + ' für C ' + level);
}

function generatePriceListProductLdJson(image, name, url, price, description) {
    let tag = '<script type="application/ld+json">\n' +
        '        {   "@context": "http://schema.org",\n' +
        '            "@type": "Product",\n' +
        '            "image": "https://wilk-lernhilfe.at/img/' + image + '",\n' +
        '            "name": "' + name + '",\n' +
        '            "url": "' + url + '",\n' +
        '                       "brand": {' +
        '                           "@type": "Organization",\n' +
        '                           "name": "WILK-Lernhilfe",\n' +
        '                           "sameAs": "https://wilk-lernhilfe.at"\n' +
        '                           },\n' +
        '            "offers":{"@type": "Offer",\n' +
        '                       "priceCurrency": "EUR",\n' +
        '                       "availability": "https://schema.org/InStock",\n' +
        '                       "priceValidUntil": "' + pricesProductsValidUntil + '"\n,' +
        '                       "url": "' + url + '",\n' +
        '                       "image": "https://wilk-lernhilfe.at/img/' + image + '",\n' +
        '                       "price": "' + price + '"}  ,\n' +
        '            "description":"' + description + '"}\n' +
        '    </script>';
    $('head').append($(tag));
}

function createSummerCourseLdJson() {
    let tag = createCourseLdJson("Sommerintensivkurs",
        courses.Sommerintensivkurs.url,
        courses.Sommerintensivkurs.description, createCourseInstancesSummer());
    $('head').append($(tag));
}

function createCourseInstancesSummer() {
    let weeks = courses.Sommerintensivkurs.Weeks;
    let result = '[';
    for (let i = 0; i < weeks.length; i++) {
        let week = weeks[i];
        let start = week.startDate;
        let end = week.endDate;
        for (let courseTyp in week.courses) {
            let image = week.courses[courseTyp].image;
            let name = week.courses[courseTyp].name;
            for (let size in week.courses[courseTyp].groupSizes) {
                for (let amountType in week.courses[courseTyp].groupSizes[size]) {
                    let courseInstance = '    {\n' +
                        '      "@type": "CourseInstance",\n' +
                        '      "startDate": "' + start + '",\n' +
                        '      "endDate": "' + end + '",\n' +
                        '      "location": ' +
                        '       {"name":"WILK-Lernhilfe",  "address": {\n' +
                        '                "@type": "PostalAddress",\n' +
                        '                "addressCountry": "AT",\n' +
                        '                "addressLocality": "Wien",\n' +
                        '                "postalCode": "1210",\n' +
                        '                "streetAddress": "Hermann Bahr Straße 18/4A"\n' +
                        '            }}' +
                        ',\n' +
                        '      "name": "Sommerintensivkurs ' + name + ' ' + size + ' ' + week.courses[courseTyp].groupSizes[size][amountType].name + '",\n' +
                        '      "description": "' + week.courses[courseTyp].description + '",\n' +
                        '      "image": "' + image + '",\n' +
                        '      "url": "https://wilk-lernhilfe.at/de/Nachhilfe/Ferienintensivkurse/Sommerintensivkurs",\n' +
                        '      "offers": {\n' +
                        '        "@type": "Offer",\n' +
                        '        "price": "' + week.courses[courseTyp].groupSizes[size][amountType].price + '",\n' +
                        '        "priceCurrency": "EUR"\n' +
                        '      }},\n';
                    result = result + courseInstance;
                }
            }
        }
    }

    return result.slice(0, -2) + ']';
}

function createCourseLdJson(courseName, url, description, courseInstanceArray) {

    return '<script type="application/ld+json">\n' +
        '{ "@context": "http://schema.org/",\n' +
        '  "@type": "Course",\n' +
        '  "name": "' + courseName + '",\n' +
        '  "provider": {' +
        '       "@type": "Organization",\n' +
        '    "name": "WILK-Lernhilfe",\n' +
        '    "sameAs": "https://wilk-lernhilfe.at"\n' +
        '  },\n' +
        '  "url": "' + url + '",\n' +
        '  "description": "' + description + '",\n' +
        '  "hasCourseInstance":' + courseInstanceArray +
        '}' +
        '    </script>';
}